import { VueEditor, Quill } from 'vue2-editor';
import $ from 'jquery';
import QuillHashtag from './QuillHashtag';
import Font from './QuillFonts';

const VueEditorMixins = {
  components: {
    VueEditor,
  },
  props: {
    value: {
      default: '',
    },
  },
  data() {
    return {
      isFocused: false,
      lastFont: null,

      // uniqid: Date.now(),
      uniqid: Math.random().toString(36).substr(2, 9),
    };
  },
  methods: {
    initQuill() {
      Font.whitelist = this.fonts.map((i) => i.font_family);
      Quill.register(Font, false);
      Quill.register(QuillHashtag);

      this.$nextTick().then(() => {
        this.$refs[this.uniqref].quill.format('font', Font.whitelist[0]);
      });
    },
    addCustomTag(tag) {
      this.selection = this.$refs[this.uniqref].quill.getSelection();
      const index = this.selection.index ? this.selection.index : 0;
      const format = this.$refs[this.uniqref].quill.getFormat();

      this.$refs[this.uniqref].quill.insertEmbed(index, 'hashtag', {
        value: tag,
        format,
      });

      this.$refs[this.uniqref].quill.insertText(index + 1, ' ', '', true);
      this.$refs[this.uniqref].quill.setSelection(index + 2);
    },
    selectionChange(range, oldRange, source) {
      // console.log(this.$refs[this.uniqref].quill.getFormat())
      this.selection = range;
    },
    html() {
      return this.content.text;
    },
    cleanTags(content) {
      const dom = $(content);
      // dont change this method without asking Felipe. Quill adds a BOM that needs to be cleaned.
      dom.find('.quill-hashtag').replaceWith(
        '<span class="quill-hashtag">Name</span>', // SR-1888
      );
      let lines = '';
      for (const d of dom) { // eslint-disable-line no-restricted-syntax
        lines += d.outerHTML;
      }

      return lines;
    },
    cleanLinks(content) {
      // find all links that are not parsed
      const dom = $(content);
      dom.find('a').not('.clean').replaceWith(function () {
        const href = $(this).attr('href');
        if (!href.startsWith('http://') && !href.startsWith('https://')) {
          $(this).attr('href', `http://${href}`);
        }
        return $(this).addClass('clean');
      });

      let lines = '';
      for (const d of dom) { // eslint-disable-line no-restricted-syntax
        lines += d.outerHTML;
      }
      return lines;
    },
    onEditorReady() {
      // Set listener to all font selectors
      const vm = this;
      const options = $('.ql-font.ql-picker').find($('.ql-picker-item'));
      options.each((index, element) => {
        $(element).click(() => {
          vm.lastFont = element.dataset.value;
        });
      });
      // Set a font as default (should take the first)
      this.setDefaultFont();
    },
    /** 'Clicks' on a proper font when no font is explicitly set. */
    setDefaultFont() {
      const vm = this;
      this.$nextTick().then(() => {
        const selectorRef = `qlFontSelect${this.uniqid}`;
        if (!this.$refs[selectorRef]) {
          return;
        }
        const hasSelected = this.$refs[selectorRef].selectedIndex >= 0;
        if (!hasSelected) {
          // Case when line doesn't have any font selected
          const lastFontOption = vm.lastFont
            ? $(`#formatsToolbar${this.uniqid}`).find('.ql-font.ql-picker').find(`.ql-picker-item[data-value="${vm.lastFont}"]`)
            : $(`#formatsToolbar${this.uniqid}`).find('.ql-font.ql-picker').find('.ql-picker-item')[0];
          lastFontOption.click();
        }
      });
    },
    /** Takes care of maintaining proper selected font on cursor change. */
    onEditorChange(name, item1, item2, who) {
      if (!this.isFocused) {
        return;
      }
      const length1 = item1 ? item1.length : null;
      const length2 = item2 ? item2.length : null;
      if (who !== 'user' || name !== 'selection-change' || length1 !== 0 || length2 !== 0) {
        return;
      }
      const activefont = $('.ql-picker-label.ql-active'); // can have length 0
      const currentVisibleFont = activefont.length ? activefont[0].dataset.value : undefined;// data('value')
      if (currentVisibleFont) {
        this.lastFont = currentVisibleFont;
      }
      this.setDefaultFont();
    },
  },
  watch: {
    fontsLoaded: {
      handler(value) {
        if (value === true) {
          this.initQuill();
        }
      },
      immediate: true,
    },
    value: {
      handler() {
        this.content = this.value;
      },
      immediate: true,
    },
    content() {
      let newcontent = this.content.replace('<span class="ql-cursor">\ufeff</span>', '');
      newcontent = this.cleanLinks(newcontent);
      const lines = this.cleanTags(newcontent);
      this.$emit('input', lines);
      if (this.cleanContent !== undefined) {
        this.cleanContent = lines;
      }

      this.setDefaultFont();
    },
  },
  computed: {
    fontsLoaded() {
      return this.$store.state.fonts.loaded;
    },
    fonts() {
      return this.$store.state.fonts.items;
    },
    textboxFonts() {
      return this.fonts.filter((font) => font.in_textboxes);
    },
    /**
            Returns institution's default font.
        */
    defaultFont() {
      return this.fonts.filter((font) => font.is_institution_default === true)[0];
    },
    uniqref() {
      return `editorRef${this.uniqid}`;
    },
  },
};
export default VueEditorMixins;
